<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-left">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
    </div>
    <div class="container text-left">
      <b-card class="mt-2">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="title">Dishes to Eat in Alabama</h1>
          </div>
          <div class="col-lg-6 text-right">
            <router-link :to="{ name: 'dishes create' }">
              <button class="btn btn-secondary"><font-awesome-icon class="icon" icon="plus" /> New Dish</button>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table table-sm table-striped text-left">
                <thead>
                  <tr class="text-left">
                    <th>Name</th>
                    <th>Cuisine</th>
                    <th>Restaurant</th>
                    <th>Brochure Year</th>
                    <th>Featured</th>
                    <th>Active</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tr-sections" v-for="dish in $store.state.misc.dishes.dishes" :key="dish.id">
                    <td>
                      <router-link :to="{ name: 'dishes edit', params: { dishId: dish._id } }" class="link">{{ dish.name }}</router-link>
                    </td>
                    <td>
                      <span v-for="(cuisine, index) in dish.cuisines" :key="index">
                        <div>{{ cuisine }}</div>
                      </span>
                    </td>
                    <td>
                      <span v-for="(location, index) in dish.locations" :key="index">
                        <div>{{ location.name ? location.name : '' }}</div>
                      </span>
                    </td>
                    <td>
                      <span>{{ dish.brochure_year }}</span>
                    </td>
                    <td>
                      <span v-if="dish.is_featured === '1'">
                        <font-awesome-icon icon="star" size="1x" style="color: var(--blue-900)" class="mr-1 fas fa-star" />
                      </span>
                    </td>
                    <td>
                      <span v-if="dish.is_active === '1'">
                        <font-awesome-icon icon="star" size="1x" style="color: var(--blue-900)" class="mr-1 fas fa-star" />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="pagination justify-content-end mt-5">
          <div class="total-count">Total Records: {{ $store.state.misc.fullCount.toLocaleString() }}</div>
          <b-pagination
            v-if="$store.state.misc.fullCount > 0"
            :value="$store.state.misc.page.page"
            :total-rows="$store.state.misc.fullCount"
            :per-page="$store.state.misc.page.pageSize"
            :hide-ellipsis="true"
            @change="changePage"
          />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      locations: [],
      Breadcrumbs: [
        {
          text: 'Dashboard',
          href: '/admin',
          active: false,
        },
        {
          text: 'Content',
          active: true,
        },
        {
          text: 'Dishes',
          active: true,
        },
      ],
    };
  },

  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch('misc/getDishes');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async changePage(page) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('misc/setPage', page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async sort(field) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('misc/sortDishes', field);
        this.sortField = this.sortDict[field];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  vertical-align: baseline;
}
th {
  width: 0px;
}
.icon {
  font-size: 12px;
  line-height: 30px !important;
  padding-right: 2px;
  text-align: center;
}
.link {
  color: #212529 !important;
  text-decoration: underline;
}
.card {
  border: none;
}
.title {
  margin: 0px 0px 100px 0px;
}
.pagination {
  padding-left: 20px;
}
</style>
